/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<HumanCapitalCompany>, schemaOptions: { partial: true })
 */
export interface HumanCapitalCompanyPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    humanCapitalManagerId?: number;
    humanCapitalDirectorId?: number;
    companyId?: string;
    payrollManagerId?: number;
    generalManagerId?: number;
    compensationManagerId?: number;
    payrollStaffId?: number;
    humanCapitalStaffId?: number;
    humanCapitalStaff2Id?: number;
}

